import { render } from "./AddressForm.vue?vue&type=template&id=20e27432"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"

import "./AddressForm.vue?vue&type=style&index=0&id=20e27432&scroped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__